import React, { useCallback } from 'react';
import { RiStackLine } from 'react-icons/ri';

import { SET_EDITOR_PREFERENCES } from '../../actions/setEditorPreferences';
import { useStore } from '../../hooks';
import TopbarIconButton from './TopbarIconButton';

const LayersPanelToggle = () => {
  const { dispatch, editorPreferences = {}, t } = useStore();
  const open = Boolean(editorPreferences.layersPanelOpen);

  const toggle = useCallback(() => {
    dispatch({
      type: SET_EDITOR_PREFERENCES,
      payload: { layersPanelOpen: !open },
    });
  }, [dispatch, open]);

  const label = t('layersModeTitle') || 'Toggle layers panel';

  return (
    <TopbarIconButton
      className={open ? 'respark_topbar-btn--on' : ''}
      title={label}
      ariaPressed={open}
      onClick={toggle}
    >
      <RiStackLine size={18} aria-hidden />
    </TopbarIconButton>
  );
};

export default LayersPanelToggle;
